import React, { useState, useEffect } from 'react';
import { ILoader } from '~/_base/components/helixIcons';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
interface Props {
  delay?: number;
  message?: string;
  fullScreen?: boolean;
}

export default function Spinner(props: Props) {
  const { delay, message } = props;
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), delay);
    return () => clearTimeout(timer);
  });

  return show === true ? (
    <Box
      sx={{
        m: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...(props.fullScreen && {
          position: 'fixed',
          paddingTop: '30vh',
          backgroundColor: 'rgb(0,0,0,0.2)',
          zIndex: 1399, // 1 below Material-UI snackbars (error/success etc)
          width: '100vw',
          height: '100vh',
          display: 'block',
          textAlign: 'center',
        }),
      }}
    >
      <ILoader fontSize="large" sx={{ m: 2 }} />
      <Typography>{message}</Typography>
    </Box>
  ) : null;
}
